window.loaded = false;
var windowWidth = 0;
var destroyablePropertySwipers = []

$(window).on('load', function(){
	window.loaded = true;
});

var homeSlider = undefined;


$(document).ready(function() {
	/* MOBILE */
	//create js hook links
	windowWidth = window.innerWidth;
	var resizeFn = function() {
		if (windowWidth != window.innerWidth) {
			windowWidth = window.innerWidth;

			$(document).trigger('civishaz.window_width_changed', windowWidth);

			checkPropertySwipers(windowWidth);
		}
	}

	window.addEventListener('resize', resizeFn);

	$(document).on('click', '.mailtolink', function(e) {
		handleMailtoLink($(this));
	});

	$('[data-purpose="navigation-link"]').each(function(){
		setNavigationUrl($(this));
	});
	
	$('[data-purpose="remodal-open"]').click(function(){
		var target = $(this).data('popup-target');
		if ($(this).data('popup-target')) {
			var item = $('[data-remodal-id="' + $(this).data('popup-target') + '"]');
			if (item.length > 0) {
				item.remodal().open();
			}
		}
	});
	
	if( $('.cookie-bar').length > 0 ) {

		$('.cookie-bar .button').click(function(){
			$('.cookie-bar').addClass('closed');

			$.ajax({
				url:ajax_controller+'setCookieConfirm',
				dataType:'json',
				type:'post',
				data:{cookie:1},
				success: function(){}
			});
		});
	}

	$('[data-purpose="remodal-close"]').click(function(){
		var value = $(this).data('value');
		if (value && value == 'confirm') {
			$('#terms-chk').attr('checked', true);
		}

		$(this).parents('.remodal').remodal().close();
	});

	$('[data-purpose="scroll-to-element"]').click(function(){
		var target = $(this).data('target');
		var item = $(target);
		var timeout = $(this).data('timeout');
		var offset = parseInt($(this).data('offset'));
		if (isNaN(timeout)) {
			timeout = 400;
		}

		if (isNaN(offset)) {
			offset = 0;
		}
		
		if (item.length > 0) {
			$('html, body').animate({scrollTop: item.offset().top - offset}, timeout);
		}
	});

	$('[data-purpose="scroll-to-element"][role="button"]').on('keydown', function(e) {
		if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
			e.preventDefault();
			$(this).trigger('click');
		}
	});

	$('[data-purpose="remodal-open"]').click(function(){
		var target = $(this).data('target');
		if (target) {
			openRemodalContent(target);
		}
	});

	$('[data-purpose="privacy-confirm-button"]').click(function(){
		var type = $(this).data('type');
		$('#privacyChk').prop('checked', type == 'accept');
		$('[data-remodal-id="privacyRemodal"]').remodal().close();
	});


	$('select').change(function(){
		var value = parseInt($(this).val());
		
		if (!value && $(this).hasClass('has-value')) {
			$(this).removeClass('has-value');
		} else if (value && !$(this).hasClass('has-value')) {
			$(this).addClass('has-value');
		}
	}).change();
		
	$('.accordion-list').each(function(ind, el) {

		var options = {};
		var th = $(el);

		if (th.data('single-active-item') != undefined) options.singleActiveItem = true;
		if (th.data('active-index') != undefined) options.activeIndex = th.data('active-index');
		if (th.data('from-width') != undefined) options.fromWidth = parseInt(th.data('from-width'));
		
		new Accordion(th, options);
  	});

  	if (typeof articleGalleryItems !== 'undefined') {
		$('.article-gallery-header-item').click(function(){
			openArticleGallery($(this));
		});
	}

	$('[data-purpose="lang-chooser"]').on('change', function(){
		var option = $(this).find('option:selected');
		if (option && option.length === 1) {
			var url = option.data('url');
			if (url) {
				document.location.href = url;
			}
		}
	});

	initGalleries();
	initLightGalleryAccessibility();
	initTooltipster();
	initHighlightedPropertySwipers();
	initHeaderMenuAccessibility();

	$('[data-purpose="open-list-button"]').on('click', function () {
		$(this).parents('.properties-container').find('.properties-list').toggleClass('opened');
		$(this).toggleClass('opened');
	});

	$('[data-purpose="social-share"]').on('click', function() {
		handleSocialShare($(this).data('platform'));
	});

	$('.document-box [data-purpose="archive-button"]').on('click', function() {
    	$(this).closest('.document-item').toggleClass('opened');
	});	

	$('.static-content table').each(function() {
		var tableOuter = $('<div>', {
			class: 'table-container',
		});

		tableOuter.insertAfter($(this));
		tableOuter.append($(this));
	});

	$(document).on('closing', '.remodal', function (e) {
		var target = $(e.target);
		handleVideo(target, 'stop');

		if (target.hasClass('save-closing')) {
			saveModalClosed(target.data('content-id'));
		}
	});
});

function saveModalClosed(itemId) {
	$.ajax({
		url: ajax_controller + 'save_modal_close',
		type: 'post',
		dataType: 'json',
		data: {
			itemId: itemId
		},
		success: function (response) {}
	});
}

var documentTypeSections = undefined;
function initDocumentPageScroll() {
	documentTypeSections = $('[data-purpose="document-type-section"]');
	if (documentTypeSections.length === 0) {
		return;
	}

	checkDocumentPageScroll();

	var focusDocumentTypeRow = function(sectionId) {
		if (!sectionId) {
			return;
		}

		var typeRow = $('.documents-page .type-row[data-type="' + sectionId + '"]').first();
		if (typeRow.length === 0) {
			return;
		}

		typeRow.trigger('focus');
	};

	$('.documents-page .type-row').off('click.civisDocumentNav').on('click.civisDocumentNav', function() {
		var currentItem = $(this);
		var targetId = currentItem.attr('aria-controls');
		if (!targetId) {
			return;
		}

		var targetSection = $('#' + targetId);
		if (targetSection.length === 0) {
			return;
		}

		var firstDocumentLink = targetSection.find('.document-item .name, .document-item .icon-outer, .archive-container .version').filter(':visible').first();
		if (firstDocumentLink.length === 0) {
			return;
		}

		setTimeout(function() {
			if (document.activeElement !== currentItem.get(0)) {
				return;
			}

			firstDocumentLink.trigger('focus');
		}, 450);
	});

	$('.documents-page .documents-container').off('keydown.civisDocumentNav').on('keydown.civisDocumentNav', '.document-item .name, .document-item .icon-outer, .archive-container .version', function(evt) {
		var isBackspace = evt.key === 'Backspace' || evt.keyCode === 8;
		if (!isBackspace) {
			return;
		}

		var documentSection = $(this).closest('[data-purpose="document-type-section"]');
		if (documentSection.length === 0) {
			return;
		}

		evt.preventDefault();
		focusDocumentTypeRow(documentSection.attr('id'));
	});

	window.addEventListener('scroll', checkDocumentPageScroll);
	window.addEventListener('touchmove', checkDocumentPageScroll);
	window.addEventListener('touchend', checkDocumentPageScroll);
}

var activeDocumentSection = null;
function checkDocumentPageScroll() {
	var currentDocumentSection = null;
	var scrollTop = $(window).scrollTop();
	documentTypeSections.each(function() {
		var top = $(this).offset().top - 10;
		if (null === currentDocumentSection || top < scrollTop) {
			currentDocumentSection = $(this).attr('id');
		}
	});

	if (currentDocumentSection !== activeDocumentSection) {
		activeDocumentSection = currentDocumentSection;
		var typeRows = $('.type-row');
		typeRows.removeClass('active').attr('aria-current', 'false');
		typeRows.filter('[data-type="' + activeDocumentSection + '"]').addClass('active').attr('aria-current', 'true');
	}
}

function handleSocialShare(platform)
{
	switch (platform) {
		case 'facebook':
			window.open('https://www.facebook.com/sharer/sharer.php?u=' + window.location.href);
			break;
	}
}

function openRemodalContent(remodal_id) {
	var tmp = $('[data-remodal-id="'+remodal_id+'"]');
	if(tmp.length > 0){
	  tmp.remodal().open();

	  handleVideo(tmp, 'start');
	}
}

function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

function sendAnalyticsEvent(action, category, tag) {
	if (typeof gtag !== 'undefined' && action && category) {
		var evtData = {
			event_category: category,
		};

		if (tag && tag.trim() != '') {
			evtData.event_label = tag;
		}
		
		gtag('event', action, evtData);
	} else if(typeof ga != 'undefined' && action && category){
		if(tag && tag.trim() != ''){
			ga('send', 'event', action, category, tag);
		}else{
			ga('send', 'event', action, category);
		}
	}
}

function svg(id) {
	return '<span class="svg"><svg class="icon ' + id + '"><use xlink:href="#' + id + '" /></svg></span>';
}


function handleMailtoLink(th) {
	if (th.attr('href') == 'javascript:void(0)') {
		var hidden = th.children('.emailhidden');
		th.attr('href', 'mailto:' + hidden.data('user') + '@' + hidden.data('domain'));
	}
}


function loadJs(url, implementationCode){
    var scriptTag = document.createElement('script');
    scriptTag.src = url;

    scriptTag.onload = implementationCode;
    scriptTag.onreadystatechange = implementationCode;

    document.body.appendChild(scriptTag);
};

function setNavigationUrl(item) {
	var address = item.data('address');
	
	if (address) {
		var itemProtocol = item.data('protocol');
		var protocol = itemProtocol ? itemProtocol : 'google';
		var ua = navigator.userAgent.toLowerCase();
		var plat = navigator.platform;
		var device = ua.match(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera/i) ? ua.match(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera/i)[0] : false;

		if(!itemProtocol && (device == 'iphone' || device == 'ipad' || device == 'ipod')) {
			function iOSversion() {
					
				if (/iP(hone|od|ad)/.test(navigator.platform)) {
				  var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
				  return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
				}
			}

			var ver = iOSversion() || [0];
			if (ver[0] >= 6) {
				protocol = 'apple';
			}
		}
		
		var urlSuffix = '/?daddr='+address;
		var nav_url = '';
		switch(protocol) {
			case 'apple':
				nav_url = 'maps://';
				break;
			default:
				nav_url = 'https://maps.google.com/maps';
				break;
		}
		item.attr('target', '_blank');
		item.attr('href', nav_url+urlSuffix);
	}
}


function openGallery(item) {
	var groupId = item.data('group-id');
	var index = item.data('index');
	
	if (typeof galleryItems === 'object' && typeof galleryItems[groupId] !== 'undefined') {
		if (!index) {
			index = 0;
		}

		initGallery(item, galleryItems[groupId], index);
	} 
}

function openArticleGallery(item) {
	var groupId = $(item).data('gallery-id');
	if (groupId && typeof articleGalleryItems === 'object' && typeof articleGalleryItems[groupId] !== 'undefined') {
		initGallery(item, articleGalleryItems[groupId]);
	}
}

function getLightGalleryFocusableControls() {
	var galleryRoot = $('.lg-outer.lg-visible').last();
	if (galleryRoot.length === 0) {
		return $();
	}

	var controls = galleryRoot.find('.lg-close, .lg-prev, .lg-next').filter(function() {
		return !$(this).hasClass('disabled');
	});

	if (controls.length === 0) {
		controls = galleryRoot.find('.lg-close, .lg-prev, .lg-next');
	}

	controls.attr('tabindex', '0').attr('role', 'button');
	return controls;
}

function initLightGalleryAccessibility() {
	$(document).off('keydown.civisGalleryTrap focusin.civisGalleryTrap');

	$(document).on('keydown.civisGalleryTrap', function(e) {
		if (!$('body').hasClass('lg-on')) {
			return;
		}

		var controls = getLightGalleryFocusableControls();
		if (controls.length === 0) {
			return;
		}

		var isTab = e.key === 'Tab' || e.keyCode === 9;
		if (isTab) {
			e.preventDefault();

			var currentIndex = controls.index(document.activeElement);
			var nextIndex = 0;

			if (e.shiftKey) {
				nextIndex = currentIndex <= 0 ? controls.length - 1 : currentIndex - 1;
			} else {
				nextIndex = currentIndex === -1 || currentIndex >= controls.length - 1 ? 0 : currentIndex + 1;
			}

			controls.eq(nextIndex).trigger('focus');
			return;
		}

		var isActivate = e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32;
		if (isActivate && $(e.target).is('.lg-close, .lg-prev, .lg-next')) {
			e.preventDefault();
			$(e.target).trigger('click');
		}
	});

	$(document).on('focusin.civisGalleryTrap', function(e) {
		if (!$('body').hasClass('lg-on')) {
			return;
		}

		if ($(e.target).closest('.lg-outer.lg-visible').length > 0) {
			return;
		}

		var controls = getLightGalleryFocusableControls();
		if (controls.length > 0) {
			controls.first().trigger('focus');
		}
	});
}

function initGallery(target, items, index) 
{
	if (!index) {
		index = 0;
	}

	var galleryTarget = $(target);
	var focusControlByClass = function(galleryRoot, className) {
		if (!className) {
			return false;
		}

		var control = galleryRoot.find('.' + className).not('.disabled').first();
		if (control.length > 0) {
			control.trigger('focus');
			return true;
		}

		return false;
	};

	var bindGalleryAccessibility = function(focusTargetClass) {
		setTimeout(function() {
			var galleryRoot = $('.lg-outer.lg-visible').last();
			if (galleryRoot.length === 0) {
				return;
			}

			var controls = getLightGalleryFocusableControls();
			if (controls.length === 0) {
				return;
			}

			if (focusControlByClass(galleryRoot, focusTargetClass)) {
				return;
			}

			if (focusControlByClass(galleryRoot, 'lg-close')) {
				return;
			}

			controls.first().trigger('focus');
		}, 0);
	};

	galleryTarget.off('onAfterOpen.lg.civisGalleryA11y onAfterSlide.lg.civisGalleryA11y onCloseAfter.lg.civisGalleryA11y');
	galleryTarget.on('onAfterOpen.lg.civisGalleryA11y', function() {
		bindGalleryAccessibility('lg-close');
	});
	galleryTarget.on('onAfterSlide.lg.civisGalleryA11y', function() {
		var activeElement = document.activeElement;
		var preferredControlClass = '';

		if ($(activeElement).hasClass('lg-next')) {
			preferredControlClass = 'lg-next';
		} else if ($(activeElement).hasClass('lg-prev')) {
			preferredControlClass = 'lg-prev';
		} else if ($(activeElement).hasClass('lg-close')) {
			preferredControlClass = 'lg-close';
		}

		bindGalleryAccessibility(preferredControlClass);
	});
	galleryTarget.on('onCloseAfter.lg.civisGalleryA11y', function() {});

	$(target).lightGallery({
		dynamic:true,
		dynamicEl:items,
		index:index,
		hash:false,
		download: false
	});
}

function initGalleries()
{
	if (typeof mediaGroupItems === 'object' && Object.keys(mediaGroupItems).length > 0) {
		$('[data-purpose="gallery-box-item"]:not(.initialized)').each(function(){
			$(this).addClass('initialized');
			$(this).click(function(){
				var id = $(this).data('group-id');
				if (id && typeof mediaGroupItems[id] !== 'undefined') {
					var index = $(this).data('index');
					initGallery($(this), mediaGroupItems[id], index);
				}
			});
		});
	}
}

function initHeaderMenuAccessibility()
{
	var header = $('.main-header');
	if (header.length === 0) {
		return;
	}

	var items = header.find('.main-menu .menu-item.has-submenu');
	if (items.length === 0) {
		return;
	}

	var closeItem = function(item) {
		item.find('[data-purpose="submenu-trigger"]').attr('aria-expanded', 'false');
	};

	var openItem = function(item) {
		items.not(item).each(function() {
			closeItem($(this));
		});

		item.find('[data-purpose="submenu-trigger"]').attr('aria-expanded', 'true');
	};

	var closeAll = function() {
		items.each(function() {
			closeItem($(this));
		});
	};

	items.on('mouseenter', function() {
		openItem($(this));
	});

	items.on('mouseleave', function() {
		if (!$(this).find(':focus').length) {
			closeItem($(this));
		}
	});

	items.on('focusout', function() {
		var currentItem = $(this);
		setTimeout(function() {
			if (currentItem.find(':focus').length === 0) {
				closeItem(currentItem);
			}
		}, 0);
	});

	header.find('[data-purpose="submenu-trigger"][role="button"]').on('click', function(e) {
		e.preventDefault();
		var item = $(this).closest('.menu-item.has-submenu');
		if ($(this).attr('aria-expanded') === 'true') {
			closeItem(item);
			return;
		}

		openItem(item);
	});

	header.find('[data-purpose="submenu-trigger"][role="button"]').on('keydown', function(e) {
		if (e.key !== 'Enter') {
			return;
		}

		e.preventDefault();
		$(this).trigger('click');
	});

	header.find('[data-purpose="submenu-trigger"]').on('keydown', function(e) {
		if (e.key !== ' ') {
			return;
		}

		e.preventDefault();
		$(this).trigger('focus');
		var item = $(this).closest('.menu-item.has-submenu');
		if ($(this).attr('aria-expanded') === 'true') {
			closeItem(item);
			return;
		}

		openItem(item);
	});

	$(document).on('keydown', function(e) {
		var isEscape = false;
		if ('key' in e) {
			isEscape = (e.key === 'Escape' || e.key === 'Esc');
		} else {
			isEscape = (e.keyCode === 27);
		}

		if (!isEscape) {
			return;
		}

		var activeTrigger = header.find('[data-purpose="submenu-trigger"][aria-expanded="true"]').first();
		if (activeTrigger.length === 0) {
			return;
		}

		closeAll();
		activeTrigger.trigger('focus');
	});

	$(document).on('click', function(e) {
		if ($(e.target).closest('.main-header .main-menu').length === 0) {
			closeAll();
		}
	});
}

function initTooltipster()
{
	$.fn.tooltipster('setDefaults', {
		position: 'bottom',
		trigger:'click'
	});

	var getOpenTooltip = function() {
		return $('.tooltipster-base.tooltipster-show').last();
	};

	var getTooltipFocusableElements = function() {
		return getOpenTooltip().find('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(':visible');
	};

	var getPageFocusableElements = function() {
		return $('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
			.filter(':visible')
			.filter(function() {
				return $(this).closest('.tooltipster-base').length === 0;
			});
	};

	var focusNextElementAfter = function(origin) {
		if (!origin || origin.length === 0) {
			return false;
		}

		var focusableElements = getPageFocusableElements();
		var currentIndex = focusableElements.index(origin);
		if (currentIndex === -1) {
			return false;
		}

		var nextElement = focusableElements.eq(currentIndex + 1);
		if (nextElement.length === 0) {
			return false;
		}

		nextElement.trigger('focus');
		return true;
	};

	$('.tooltipster-item:not(.initialized)').each(function(){
		var item = $(this);
		$(this).addClass('initialized');
		var tooltipContent = $(this).data('tooltip-content');
		$(this).tooltipster({
			position:'top',
			contentAsHTML:true,
			trigger: isDeviceTouchable() ? 'click' : 'hover',
			contentCloning: tooltipContent ? true : false,
			interactive: true,
			functionBefore: function(orig, tooltip) {
				$(tooltip.origin).addClass('opened');
			},
			functionAfter: function(orig, tooltip) {
				$(tooltip.origin).removeClass('opened');
			}
		});

		if (item.hasClass('coworker-tooltip-item')) {
			item.on('focus', function() {
				$(this).tooltipster('open');
			});

			item.on('blur', function() {
				var currentItem = $(this);

				setTimeout(function() {
					var activeElement = $(document.activeElement);
					var openTooltip = getOpenTooltip();

					if (activeElement.is(currentItem)) {
						return;
					}

					if (openTooltip.length > 0 && activeElement.closest('.tooltipster-base').length > 0) {
						return;
					}

					currentItem.tooltipster('close');
				}, 0);
			});

			item.on('keydown', function(evt) {
				var isTab = evt.key === 'Tab' || evt.keyCode === 9;
				var isEnter = evt.key === 'Enter' || evt.keyCode === 13;
				var isSpace = evt.key === ' ' || evt.key === 'Spacebar' || evt.code === 'Space' || evt.keyCode === 32;

				if (isTab && !evt.shiftKey && $(this).hasClass('opened')) {
					var focusableElements = getTooltipFocusableElements();
					if (focusableElements.length > 0) {
						evt.preventDefault();
						focusableElements.first().trigger('focus');
					}
					return;
				}

				if (!isEnter && !isSpace) {
					return;
				}

				evt.preventDefault();

				if ($(this).hasClass('opened')) {
					$(this).tooltipster('close');
					return;
				}

				$(this).tooltipster('open');
			});
		}
	});

	$(document).off('keydown.coworkerTooltipA11y').on('keydown.coworkerTooltipA11y', '.tooltipster-base.tooltipster-show a, .tooltipster-base.tooltipster-show button, .tooltipster-base.tooltipster-show [tabindex]:not([tabindex="-1"])', function(evt) {
		var isTab = evt.key === 'Tab' || evt.keyCode === 9;
		if (!isTab) {
			return;
		}

		var focusableElements = getTooltipFocusableElements();
		if (focusableElements.length === 0) {
			return;
		}

		var firstElement = focusableElements.first()[0];
		var lastElement = focusableElements.last()[0];
		var origin = $('.coworker-tooltip-item.opened').last();

		if (evt.shiftKey && this === firstElement && origin.length > 0) {
			evt.preventDefault();
			origin.trigger('focus');
			return;
		}

		if (!evt.shiftKey && this === lastElement && origin.length > 0) {
			evt.preventDefault();
			origin.tooltipster('close');
			if (!focusNextElementAfter(origin)) {
				origin.trigger('focus');
			}
		}
	});
}

function initHighlightedPropertySwipers()
{
	var items = document.querySelectorAll('[data-purpose="highlighted-properties-swiper"]');

	items.forEach(function (item) {
		if (!item.classList.contains('swiper-container-initialized') && (windowWidth > 600 || !item.classList.contains('disable-on-mobile'))) {
			var swiperOptions = {
				slidesPerView: 3,
				slidesPerGroup: 3,
				direction: 'horizontal',
				spaceBetween: 30,
				autoHeight: false,
				enabled: false,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				breakpoints: {
					601: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 20,
						enabled: true
					},
					1023: {
						slidesPerView: 3,
						slidesPerGroup: 3,
						spaceBetween: 30,
						enabled: true
					}
				},
			};
		
			if (item.querySelectorAll('.swiper-pagination').length === 0) {
				delete(swiperOptions.pagination);
			}
		
			if (item.querySelectorAll('.swiper-pagination').length > 0) {
				item.classList.add('has-pagination');
			}
		
			if (item.querySelectorAll('.swiper-button').length === 0) {
				delete(swiperOptions.navigation);
			}
		
			var swiperObj = initSwiperObject(item, swiperOptions);
		
			if (item.classList.contains('disable-on-mobile')) {
				destroyablePropertySwipers.push(swiperObj);
			}
		}
	});
}

function checkPropertySwipers(windowWidth) {
	if (600 >= windowWidth && 0 < destroyablePropertySwipers.length) {
		destroyablePropertySwipers.forEach(function (item) {
			if (item.el.querySelectorAll('.swiper-pagination').length > 0) {
				item.el.querySelector('.swiper-pagination').innerHTML = '';
			}

			item.destroy();
		});

		destroyablePropertySwipers = [];
	} else if (600 < windowWidth && 0 === destroyablePropertySwipers.length) {
		initHighlightedPropertySwipers();
	}
}

function initSwiperObject(selector, options) {
	return new Swiper(selector, options);
}

function isDeviceTouchable() {
	return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}

function initCountdown(container)
{
	var deadline = container.data('deadline');
	if (!deadline) {
		container.hide();
		return;
	}

	var deadlineDate = new Date(deadline);
	var dayLength = 24 * 60 * 60 * 1000;
	var hourLength = 60 * 60 * 1000;
	var minLength = 60 * 1000;

	var updateCountdown = function () {
		var currentDate = new Date();
		var timeRemaining = deadlineDate - currentDate;

		if (timeRemaining <= 0) {
			clearInterval(countdownInterval);
			container.hide();
			return;
		}

		var days = Math.floor(timeRemaining / dayLength);
		var hours = Math.floor((timeRemaining % dayLength) / hourLength);
		var mins = Math.floor((timeRemaining % hourLength) / minLength);
		var secs = Math.floor((timeRemaining % minLength) / 1000);

		container.find('.value[data-type="day"]').html(days);
		container.find('.value[data-type="hour"]').html(hours);
		container.find('.value[data-type="min"]').html(mins);
		container.find('.value[data-type="sec"]').html(secs);
	}

	var countdownInterval = setInterval(updateCountdown, 1000);
}

function handleVideo(element, action) {
	element.find('video').each(function(index, video) {
		if ('stop' === action) {
			video.pause();
		} else if ('start' === action) {
			video.play();
		}
	});
}